<template>
  <div class="wrapper">
    <wt-header></wt-header>
    <router-view></router-view>
    <wt-footer></wt-footer>
  </div>
</template>
<script>
import wtHeader from '../../components/header.vue'
import wtFooter from '../../components/footer.vue'
export default {
  components: {
    wtHeader,
    wtFooter
  }
}
</script>
<style scoped>
.wrapper{
  position: relative;
  height:768px;
  background:rgba(255,255,255,0);
}
</style>
